import { HeroCarousel } from "../components/HeroCarousel";
import { Marquee } from "../components/Marquee";
import { FeaturedBooksPreview } from "../components/FeaturedBooksPreview";
import { WritingsPreview } from "../components/WritingsPreview";
import { Gallery } from "../components/Gallery";
import { AboutArchive } from "../components/AboutArchive";
import { Mission } from "../components/Mission";
import { Newsletter } from "../components/Newsletter";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <Marquee />
      <FeaturedBooksPreview />
      <WritingsPreview />
      <Gallery />
      <AboutArchive />
      <Mission />
      <Newsletter />
    </>
  );
}
